import {
  withFormsy,
} from 'formsy-react';

import InputTextareaView from './InputTextareaView';

// @ts-expect-error form component
const InputComponent = withFormsy(InputTextareaView);

const Component = InputComponent;

export default Component;
